import React from 'react';
import PropTypes from 'prop-types';
import ReactSwitch from 'react-switch';

import colors from 'themes/Main';
import Label from '../Label';

import * as S from './styles';

const { blue, darkBlue } = colors;

const Switch = ({
  isChecked,
  onChange,
  backgroundActiveColor,
  circleActiveColor,
  width,
  height,
  id,
  labelText,
  isFlex,
  labelPosition,
  isDisabled,
}) => (
  <S.Container isFlex={isFlex} labelPosition={labelPosition}>
    {labelText && <Label hasMargin text={labelText} />}
    <ReactSwitch
      checked={isChecked}
      onChange={onChange}
      onColor={backgroundActiveColor}
      onHandleColor={circleActiveColor}
      handleDiameter={30}
      uncheckedIcon={false}
      checkedIcon={false}
      boxShadow="0px 1px 5px rgba(0, 0, 0, 0.3)"
      activeBoxShadow="0px 0px 1px 10px rgba(0, 0, 0, 0.2)"
      height={width}
      width={height}
      className={id}
      id={id}
      disabled={isDisabled}
    />
  </S.Container>
);

Switch.defaultProps = {
  onChange: () => {},
  backgroundActiveColor: blue,
  circleActiveColor: darkBlue,
  width: 20,
  height: 48,
  labelText: '',
  isFlex: false,
  labelPosition: 'left',
  isDisabled: false,
};

Switch.propTypes = {
  isChecked: PropTypes.bool.isRequired,
  onChange: PropTypes.func,
  backgroundActiveColor: PropTypes.string,
  circleActiveColor: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  id: PropTypes.string.isRequired,
  labelText: PropTypes.string,
  isFlex: PropTypes.bool,
  labelPosition: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default Switch;
